import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useFeatureFlags } from '../../../rules/get-feature-flags'
import { useRoute } from '../../../rules/find-route'
import { useAccountDataState } from '../_accountDataState'
import { getInvestRouteId, useInvestDataState } from '../_investDataState'

const ACCOUNT_ROUTE_SEGMENT = '/account'

export const useAccountStepLock = () => {
  const location = useLocation()
  const nav = useNavigate()
  const { findRoute } = useRoute()
  const { data: featureFlagData, isLoading: areFeatureFlagsLoading } =
    useFeatureFlags()
  const {
    data: investData,
    isLoading: isInvestLoading,
    isFetching: isInvestFetching,
    refetch: refetchInvestData,
  } = useInvestDataState()
  const {
    data: accountData,
    isLoading: isAccountLoading,
    isFetching: isAccountFetching,
    refetch: refetchAccountData,
  } = useAccountDataState()

  useEffect(() => {
    if (!location.pathname.includes(ACCOUNT_ROUTE_SEGMENT)) return
    void refetchInvestData()
  }, [location.pathname, refetchInvestData])

  useEffect(() => {
    if (!location.pathname.includes(ACCOUNT_ROUTE_SEGMENT)) return
    if (!investData?.investment?.id) return
    void refetchAccountData()
  }, [location.pathname, investData?.investment?.id, refetchAccountData])

  useEffect(() => {
    if (!location.pathname.includes(ACCOUNT_ROUTE_SEGMENT)) return
    if (
      areFeatureFlagsLoading ||
      isInvestLoading ||
      isInvestFetching ||
      isAccountLoading ||
      isAccountFetching ||
      !featureFlagData ||
      !investData ||
      !accountData?.current_account ||
      investData?.investment_state?.investment_account !== 'submitted'
    ) {
      return
    }

    void findRoute(investData).then((route) => {
      if (!route?.type || route.type === 'account') return

      nav(`/invest/${getInvestRouteId()}/${route.type}`, {
        replace: true,
        state: { params: route.params },
      })
    })
  }, [
    accountData?.current_account,
    areFeatureFlagsLoading,
    featureFlagData,
    findRoute,
    investData,
    isAccountFetching,
    isAccountLoading,
    isInvestFetching,
    isInvestLoading,
    location.pathname,
    nav,
  ])
}
